<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">主页</h3>
          </div>
          <div class="box-body no-padding">
            <div style="padding: 30px;">
              <h3>欢迎使用尺半物联卡充值系统</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      user: {},
      loading: false,
      list: [],
    };
  },
  mounted() {
    const _this = this;
    _this.loading = true;
    _this.$store
        .dispatch('authInit', _this)
        .then((state) => {
          _this.user = state.user;
          _this.loading = false;
          _this.updateUrl();
        })
        .catch(() => {
          _this.loading = false;
        })
  },
  methods: {
    updateUrl() {
      const _this = this;
      const url = _this.$queryUrl(_this.$route.path, _this.query);
      _this.$router.replace({path: url});
    },
  }
}
</script>

<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>